import styles from "./TodoItem.module.css";
import React from "react";
import { FiTrash } from "react-icons/fi";
const TodoItem = React.memo(function TodoItem({
  todo,
  deleteTodo,
  handleComplete,
}) {
  return (
    <li
      className={`${styles.todoItem} ${todo.completed ? styles.completed : ""}`}
    >
      <input
        type="checkbox"
        checked={todo.completed}
        onChange={() => handleComplete(todo.id)}
      />
      <span className={styles.todoText}>
        {todo.text} ~ {todo.priority}
      </span>
      <button className={styles.deleteBtn} onClick={() => deleteTodo(todo.id)}>
        <FiTrash size={10} />
      </button>
    </li>
  );
});

export default TodoItem;
